export abstract class Query<TResult> {
    private t_result!: TResult;
}
